export default __webpack_public_path__ + "logo089b249e.png";